document.addEventListener(
  "scroll",
  (event) => {
    window.Trengo = window.Trengo || {};
    window.Trengo.key = "nGXIH7ISgspe2oJdK5bx";
    (function (d, script, t) {
      script = d.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = "https://static.widget.trengo.eu/embed.js";
      d.getElementsByTagName("head")[0].appendChild(script);
    })(document);
  },
  {
    passive: true,
    once: true,
  }
);
